<template>
  <Label
    data-slot="field-label"
    :class="
      cn(
        'tw:group/field-label tw:peer/field-label tw:flex tw:w-fit tw:gap-2 tw:group-data-[disabled=true]/field:opacity-50',
        'tw:has-[>[data-slot=field]]:w-full tw:has-[>[data-slot=field]]:flex-col tw:has-[>[data-slot=field]]:rounded-md tw:has-[>[data-slot=field]]:border tw:[&>*]:data-[slot=field]:p-4',
        'tw:has-data-[state=checked]:bg-primary/5 tw:has-data-[state=checked]:border-primary tw:dark:has-data-[state=checked]:bg-primary/10',
        props.class,
      )
    "
  >
    <slot />
  </Label>
</template>

<script setup>
import { cn } from '@/shared/utilities/classes';
import { Label } from '@/shared/components/ui/label';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    default: undefined,
    required: false,
    skipCheck: true,
  },
});
</script>
